/* src/components/customGame/player/CustomGameHeader.js */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause, faPlay, faCog } from '@fortawesome/free-solid-svg-icons'; // faCog for "Custom Game"

const CustomGameHeader = ({
    currentTrial,
    totalTrials,
    score, // Will be a simple score or placeholder initially
    onPauseResume,
    isPaused,
    // Potentially pass parts of the config here if needed for display, e.g., config.presetMetadata.name
    customGameName // Optional: name of the custom game preset
}) => {

    const trialDisplay = currentTrial < 0 ? '-' : currentTrial + 1;
    const totalTrialsDisplay = totalTrials > 0 ? totalTrials : '?';

    return (
        <header className="w-full bg-gray-800 text-white p-3 shadow-md sticky top-0 z-10">
            <div className="container mx-auto flex justify-between items-center max-w-4xl">
                {/* Left Side: Custom Game Info / Name */}
                <div className="flex items-center text-sm w-1/3">
                    <FontAwesomeIcon icon={faCog} className="mr-2 text-indigo-400" />
                    <span>{customGameName || "Custom Game"}</span>
                </div>

                {/* Center: Trial Progress & Score */}
                <div className="flex flex-col items-center text-center w-1/3">
                    <div className="text-sm font-semibold">
                        Trial: {trialDisplay} / {totalTrialsDisplay}
                    </div>
                    <div className="text-xs text-gray-300 mt-0.5">
                        Score: {score !== undefined ? score : '-'}
                    </div>
                </div>

                {/* Right Side: Pause/Resume Button */}
                <div className="flex justify-end w-1/3">
                    {typeof onPauseResume === 'function' && (
                        <button
                            onClick={onPauseResume}
                            className={`px-3 py-1.5 text-xs sm:text-sm rounded-md font-medium transition-colors shadow-sm
                                ${
                                    isPaused
                                        ? 'bg-green-500 hover:bg-green-600 text-white'
                                        : 'bg-yellow-500 hover:bg-yellow-600 text-white'
                                }`}
                            title={isPaused ? "Resume Game" : "Pause Game"}
                        >
                            <FontAwesomeIcon icon={isPaused ? faPlay : faPause} className="mr-1 sm:mr-2 h-3 w-3" />
                            {isPaused ? 'Resume' : 'Pause'}
                        </button>
                    )}
                </div>
            </div>
        </header>
    );
};

CustomGameHeader.propTypes = {
    currentTrial: PropTypes.number.isRequired,
    totalTrials: PropTypes.number.isRequired,
    score: PropTypes.number, // Score can be undefined initially
    onPauseResume: PropTypes.func.isRequired,
    isPaused: PropTypes.bool.isRequired,
    customGameName: PropTypes.string, // Optional name of the game
};

CustomGameHeader.defaultProps = {
    score: 0,
};

export default CustomGameHeader;